export default function auth({ next, to, router, store }) {
  const user = store.getters['auth/user']

  if (!user.auth) {
    return router.replace({
      // name: 'Login'
      path: `/login?redirect_url=${encodeURIComponent(window.location.href)}`
    })
  } else {
    if (to.meta.page === 'Conversations') {
      return next()
    } else if (user.role.pages.indexOf(to.meta.page) === -1) {
      return router.replace({
        name: 'Conversations'
      })
    } else {
      return next()
    }
  }
}
